import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import LoginLogoutsTabela from "./LoginLogoutsTabela";
import LoginLogoutsDialog from "./LoginLogoutsDialog";



const useStyles = makeStyles(theme => ({

}));


const LoginLogoutsMainView = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [ registro, setRegistro] = useState({
        id: 0,
        descricao: '',
        ano: 0,
        mes: 0,
        diasUteis: 0,
        metaCategoriaId: 0,
        estabelecimentoId: 0,
        turno: 0,
        objetivo: 0
    });

    useEffect( () => {



    }, []);

    const cbOpenDialog = (b,rD) => {
        console.log("mainview.cbOpenDialog", b, rD)
        setRegistro(rD);
        setDialogOpen(b);
    }


    return (
        <React.Fragment>
            { dialogOpen && <LoginLogoutsDialog isOpen={dialogOpen} cbDialog={cbOpenDialog} registro={registro} />}
                <LoginLogoutsTabela openDialog={cbOpenDialog}/>
        </React.Fragment>
    )

}

export default LoginLogoutsMainView;
